/** Every order status, in lifecycle order — UI filters iterate this list. */
export const orderStatuses = ['draft', 'submitted', 'emailed'];
//# sourceMappingURL=order.js.map